import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { WholesalerProfile } from '@/services/profile';

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  wholesaler: WholesalerProfile | null;
  isHydrated: boolean;

  setSession: (s: { accessToken: string; refreshToken: string; wholesaler: WholesalerProfile }) => void;
  setWholesaler: (s: WholesalerProfile) => void;
  setTokens: (accessToken: string, refreshToken?: string) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      wholesaler: null,
      isHydrated: false,
      setSession: (s) =>
        set({ accessToken: s.accessToken, refreshToken: s.refreshToken, wholesaler: s.wholesaler }),
      setWholesaler: (s) => set({ wholesaler: s }),
      setTokens: (accessToken, refreshToken) =>
        set({ accessToken, refreshToken: refreshToken ?? get().refreshToken }),
      logout: () => set({ accessToken: null, refreshToken: null, wholesaler: null }),
    }),
    {
      name: 'resstro_wholesaler_auth',
      onRehydrateStorage: () => (state) => {
        if (state) state.isHydrated = true;
      },
    },
  ),
);
